import React, { useState, Suspense, lazy } from 'react';
const Aside = lazy(() => import('./Aside'));
const Main = lazy(() => import('./Main'));

function Layout({ setLocale }) {
  const [rtl, setRtl] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [image, setImage] = useState(true);
  const [toggled, setToggled] = useState(false);

  // const handleCollapsedChange = (checked) => {
  //   setCollapsed(checked);
  // };

  // const handleRtlChange = (checked) => {
  //   setRtl(checked);
  //   setLocale(checked ? 'ar' : 'en');
  // };
  // const handleImageChange = (checked) => {
  //   setImage(checked);
  // };

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <div className={`app`}>
      <Suspense>
        <Aside
          image={image}
          collapsed={collapsed}
          rtl={rtl}
          toggled={toggled}
          handleToggleSidebar={handleToggleSidebar}
        />

        <Main
          // image={image}
          // toggled={toggled}
          //     collapsed={collapsed}
          //     rtl={rtl}
              handleToggleSidebar={handleToggleSidebar}
              // handleCollapsedChange={handleCollapsedChange}
              // handleRtlChange={handleRtlChange}
              // handleImageChange={handleImageChange}
        />
      </Suspense>
    </div>
  );
}

export default Layout;